<template>
    <!--FAQ Page Start-->
    <section style="padding: 40px 0 90px !important;">
            <div class="container">
                <div class="row">
                    <div class="col-xl-6 elemento-padre">
                        <img src="assets/images/other/sec.png" alt="" class="elemento-hijo">
                        <img src="assets/images/other/src-check.png" alt="" class="elemento-hijo"> 
                    </div>
                    <div class="col-xl-6">
                        <div class="box-margin">
                            <h4 class="tx-titulo">Certificación Eléctrica TE1</h4>

                            <p class="justifi">Certificar tu instalación eléctrica, ya sea domiciliaria o industrial, es un paso esencial para obtener la aprobación y los permisos de la Superintendencia de Electricidad y Combustibles (SEC). Este proceso garantiza que la instalación cumple con las normativas vigentes y brinda seguridad, ya que un profesional calificado se hace responsable ante cualquier desperfecto eléctrico.</p>
                            <p class="justifi" style="margin-top: 10px;">En IEH Electricidad nos encargamos de certificar tu instalación eléctrica y gestionamos la obtención del certificado TE1 en el menor tiempo posible (los plazos dependen de la SEC). Para ello, realizamos una visita técnica a terreno. La visita tiene un costo, el cual se deducirá del monto total si se concreta la certificación.</p>
                        </div>
                        
                        <div class="box-margin">
                            <h4 class="tx-titulo2">¿Cuál es el proceso una vez contactados?</h4>

                            <p class="justifi"></p>
                            <p class="justifi tx-espacio"></p>
                            <p class="justifi"></p>
                            <p class="justifi tx-espacio"></p>
                            <p class="justifi"></p>

                            <ul class="list-unstyled feature-one__point">
                                <li>
                                    <div >
                                        <span class="fa fa-check"></span>
                                    </div>
                                    <div class="justifi2">
                                        <p >Visita de un ingeniero eléctrico: Se realiza un levantamiento técnico de las instalaciones a certificar.</p>
                                    </div>
                                </li>
                                <li>
                                    <div >
                                        <span class="fa fa-check"></span>
                                    </div>
                                    <div class="justifi2">
                                        <p >Informe técnico eléctrico: Se entrega en formato PDF, incluyendo detalles y observaciones detectadas en las instalaciones.</p>
                                    </div>
                                </li>
                                <li>
                                    <div >
                                        <span class="fa fa-check"></span>
                                    </div>
                                    <div class="justifi2">
                                        <p >Planos eléctricos digitales: Se entregan en formato DWG (AutoCAD) y PDF de las instalaciones inscritas.</p>
                                    </div>
                                </li>
                                <li>
                                    <div >
                                        <span class="fa fa-check"></span>
                                    </div>
                                    <div class="justifi2 tx-esp">
                                        <p >Elaboración de planos arquitectónicos: Si no dispones del plano arquitectónico del recinto, se realizará uno desde cero, con un costo adicional.</p>
                                    </div>
                                </li>
                                <li>
                                    <div >
                                        <span class="fa fa-check"></span>
                                    </div>
                                    <div class="justifi2">
                                        <p >Certificado TE1: Se entrega en formato PDF, validando la inscripción y cumplimiento de las instalaciones eléctricas.</p>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div class="box-margin">

                            <p class="justifi">Nuestro compromiso es brindarte un servicio profesional, eficiente y transparente, asegurando que tu instalación eléctrica esté certificada y en regla con la normativa vigente.</p>

                        </div>
                        
                    </div>
                    
                    <!-- <div class="row">
                        <div class="col-4"></div>
                        <div class="col-8">
                            <h4 class="">-----</h4>
                        </div>
                    </div> -->

                </div>
                
            </div>
        </section>
        <!--FAQ Page End-->
  
  
</template>
<style>
        .justifi{
            text-align: justify;
        }
        .justifi2{
            text-align: justify;
            font-family: Arial, Helvetica, sans-serif !important; 
            font-weight: 0px !important;
            color: #2c3e50 !important;
            margin-left: 14px;
        }

        .tx-esp{
            margin-bottom: 2px;
        }

        .tx-titulo{
            margin-top: 10px;
            margin-bottom: 20px;
        }

        .tx-titulo2{
            margin-top: 20px;
            margin-bottom: 20px;
        }


        .tx-espacio{
            margin-top: 10px;
            margin-bottom: 10px;
        }

        .sml{
            width: 200px;
            height: 120px;
        }
        .sml2{
            width: 45%;
            height: 40%;
        }

       /* ---- */
       
       .elemento-padre {
            display: flex;
            justify-content: center;
            align-items: center;
            /* background: #666; */
                }

        .elemento-hijo {
            display: flex;
            width: 260px;
            height:  auto;
            /* background: #999; */
        }

        .box-margin{
            margin-left: 20px;
        }

        @media only screen and (max-width: 1024px){
            .elemento-hijo {
                width: 200px;
            }
            .box-margin {
                margin-left: 0px;
            }
            .tx-titulo {
                margin-top: 20px;
            }
        }

        @media only screen and (max-width: 414px){
            .justifi2 {
                margin-bottom: 6px;
            }

        }
        


    </style>
<script>

</script>